export class OrderSubsidy {
  constructor() {
    if (document.getElementById('js-subsidy_order') == null) return
    const selectElement = document.getElementById('js-subsidy_order')
    var url = new URL(window.location.href)
    selectElement.addEventListener('change', (event) => {
      var value = event.target.value
      if (url.searchParams.get('sort')) {
        var params = url.searchParams
        params.delete('sort')
        history.replaceState('', url.pathname)
      }
      url.searchParams.append('sort', value)
      var paramstr = url.searchParams
      location.href = location.origin + '/' + location.pathname + '/?' + paramstr
    })
  }
}
